import React, { FC } from 'react';
import classNames from 'classnames';

export interface LegalReacceptanceProgressBarProps {
  currentStep: number;
  totalSteps?: number;
}

const LegalReacceptanceProgressBar: FC<LegalReacceptanceProgressBarProps> = ({ currentStep, totalSteps = 4 }) => {
  return (
    <div
      className="flex w-full gap-1"
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={totalSteps}
      aria-valuenow={currentStep}
      aria-label={`Step ${currentStep} of ${totalSteps}`}>
      {Array.from({ length: totalSteps }).map((_, i) => (
        <div
          key={i}
          className={classNames('h-1 flex-1 rounded-full', {
            'bg-secondary': i < currentStep,
            'bg-gray-200': i >= currentStep
          })}
        />
      ))}
    </div>
  );
};

export default LegalReacceptanceProgressBar;
